import { useFela } from 'react-fela';

import { ConfirmationModal } from '@/modules/modals';

import { useRequestAccessPageContent } from './hooks/useRequestAccessPageContent';
import * as felaRules from './RequestAccessPage.rules';

export const RequestAccessPage = () => {
    const { css } = useFela();

    const content = useRequestAccessPageContent();

    return (
        <ConfirmationModal
            title={content.title}
            okButton={content.okButton}
            cancelButton={content.cancelButton}
            open
            icon={null}
            closable={false}
        >
            <div className={css(felaRules.description)}>{content.children}</div>
        </ConfirmationModal>
    );
};
